import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table__filter" }
const _hoisted_2 = { class: "table__filter__project" }
const _hoisted_3 = { class: "dropdown" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { class: "--align-right" }, "Order", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, "Title", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", { class: "mdl-data-table__cell--non-numeric" }, "Assignees", -1)
const _hoisted_9 = {
  key: 1,
  class: "--align-right"
}
const _hoisted_10 = {
  key: 2,
  class: "--align-right"
}
const _hoisted_11 = { key: 3 }
const _hoisted_12 = {
  key: 4,
  class: "--align-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TicketRow = _resolveComponent("TicketRow")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_CreateCompanionIssuePopup = _resolveComponent("CreateCompanionIssuePopup")!
  const _component_ReorderTicketPopup = _resolveComponent("ReorderTicketPopup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['table', (_ctx.buildingData || _ctx.connectionError) ? '--blocked' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        class: "form-input",
        type: "text",
        placeholder: "Filter Title",
        autofocus: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.titleFilter) = $event))
      }, null, 512), [
        [_vModelText, _ctx.titleFilter]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-input",
        type: "text",
        placeholder: "Filter Label",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.labelFilter) = $event))
      }, null, 512), [
        [_vModelText, _ctx.labelFilter]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-input",
        type: "text",
        placeholder: "Filter Assignee",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.assigneeFilter) = $event))
      }, null, 512), [
        [_vModelText, _ctx.assigneeFilter]
      ]),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          class: "form-input",
          type: "text",
          placeholder: "Filter Project",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.projectFilter) = $event))
        }, null, 512), [
          [_vModelText, _ctx.projectFilter]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, id) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "dropdown__entry",
              onClick: _withModifiers(($event: any) => (_ctx.setProjectFilter(id, project.name)), ["stop"])
            }, _toDisplayString(project.name), 9, _hoisted_4)), [
              [_vShow, !_ctx.projectFilter.length || project.name.toLowerCase().includes(_ctx.projectFilter.toLowerCase())]
            ])
          }), 256))
        ], 512), [
          [_vShow, _ctx.projectFilter.length && _ctx.selectedProject === -1]
        ])
      ])
    ]),
    _createElementVNode("table", null, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _hoisted_5,
          _hoisted_6,
          (_ctx.provider !== 'zammad')
            ? (_openBlock(), _createElementBlock("th", _hoisted_7, "Labels"))
            : _createCommentVNode("", true),
          _hoisted_8,
          (_ctx.provider !== 'zammad' && _ctx.view !== 'billing')
            ? (_openBlock(), _createElementBlock("th", _hoisted_9, "Estimate"))
            : _createCommentVNode("", true),
          (_ctx.provider !== 'zammad' && _ctx.view !== 'billing')
            ? (_openBlock(), _createElementBlock("th", _hoisted_10, "Logged"))
            : _createCommentVNode("", true),
          (_ctx.provider !== 'zammad')
            ? (_openBlock(), _createElementBlock("th", _hoisted_11, "Milestone"))
            : _createCommentVNode("", true),
          (_ctx.provider === 'zammad')
            ? (_openBlock(), _createElementBlock("th", _hoisted_12, "Operations"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_draggable, {
        modelValue: _ctx.currentViewList,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentViewList) = $event)),
        tag: "tbody",
        onChange: _ctx.orderChanged,
        disabled: _ctx.buildingData || _ctx.connectionError || _ctx.assigneeFilter.length || _ctx.titleFilter.length || _ctx.projectFilter.length
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentViewList, (ticketId, index) => {
            return (_openBlock(), _createBlock(_component_TicketRow, {
              ticket: _ctx.getObject(ticketId),
              assigneeFilter: _ctx.assigneeFilter,
              labelFilter: _ctx.labelFilter,
              "title-filter": _ctx.titleFilter,
              index: index + 1,
              view: _ctx.view,
              provider: _ctx.provider,
              "project-filter": _ctx.selectedProject,
              visited: _ctx.visited,
              "recently-visited": _ctx.recentlyVisited,
              onShowPopup: _ctx.displayPopup,
              onVisitedChanged: _ctx.getVisited,
              onShowOrderPopup: _ctx.displayOrderPopup,
              onSetAssigneeFilter: _ctx.setAssigneeFilter,
              onSetLabelFilter: _ctx.setLabelFilter
            }, null, 8, ["ticket", "assigneeFilter", "labelFilter", "title-filter", "index", "view", "provider", "project-filter", "visited", "recently-visited", "onShowPopup", "onVisitedChanged", "onShowOrderPopup", "onSetAssigneeFilter", "onSetLabelFilter"]))
          }), 256))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange", "disabled"])
    ]),
    _createVNode(_component_CreateCompanionIssuePopup, {
      show: _ctx.showPopup,
      ticket: _ctx.selectedTicket,
      onHidePopup: _ctx.hidePopup
    }, null, 8, ["show", "ticket", "onHidePopup"]),
    _createVNode(_component_ReorderTicketPopup, {
      show: _ctx.showOrderPopup,
      index: _ctx.selectedIndex,
      lastSetIndex: _ctx.lastSetIndex,
      onHidePopup: _ctx.hideOrderPopup,
      onChangeOrder: _ctx.updateOrder
    }, null, 8, ["show", "index", "lastSetIndex", "onHidePopup", "onChangeOrder"])
  ], 2))
}